var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "suggestionsList" }, [
    _c("div", [
      _c("div", { staticClass: "my-suggestionsList" }, [
        _c("div", { staticClass: "my-banner-tlt font36phone" }, [
          _vm._v("我的投诉建议")
        ]),
        _c("div", { staticClass: "my-banner col666666 font24phone" }, [
          _vm.myForm.phone
            ? _c("div", [
                _c("div", { staticClass: "my-banner-submit" }, [
                  _vm.myForm.supContent == ""
                    ? _c(
                        "div",
                        {
                          staticClass: "my-banner-p",
                          staticStyle: { "text-align": "right" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "my-banner-button",
                              on: {
                                click: function($event) {
                                  return _vm.addReplyComplaint()
                                }
                              }
                            },
                            [_vm._v("提交")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "my-banner-p" }, [
                    _c("span", { staticClass: "my-banner-p-bold" }, [
                      _vm._v("联系手机：" + _vm._s(_vm.myForm.phone))
                    ])
                  ]),
                  _c("div", { staticClass: "my-banner-p" }, [
                    _c("span", { staticClass: "my-banner-p-bold" }, [
                      _vm._v("提交时间：")
                    ]),
                    _vm._v(
                      _vm._s(
                        _vm.$myConvertTimeDetails(_vm.myForm.submissionTime)
                      ) + "\n            "
                    )
                  ]),
                  _c("div", { staticClass: "my-banner-p" }, [
                    _c("span", { staticClass: "my-banner-p-bold" }, [
                      _vm._v("反馈类型：")
                    ]),
                    _vm._v(_vm._s(_vm.myForm.feedbackType) + "\n            ")
                  ]),
                  _c("div", { staticClass: "my-banner-p" }, [
                    _c(
                      "span",
                      { staticClass: "my-banner-p-bold my-textarea" },
                      [_vm._v("详细内容：")]
                    ),
                    _c("p", [_vm._v(_vm._s(_vm.myForm.details))])
                  ]),
                  _c(
                    "div",
                    { staticClass: "my-banner-p" },
                    [
                      _c(
                        "span",
                        { staticClass: "my-banner-p-bold my-textarea" },
                        [_vm._v("补充内容：")]
                      ),
                      _vm.myForm.supContent
                        ? _c("p", [_vm._v(_vm._s(_vm.myForm.supContent))])
                        : _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "200",
                              "show-word-limit": ""
                            },
                            model: {
                              value: _vm.toSupContent,
                              callback: function($$v) {
                                _vm.toSupContent = $$v
                              },
                              expression: "toSupContent"
                            }
                          })
                    ],
                    1
                  )
                ]),
                _c("div", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.myForm.replyTime,
                          expression: "myForm.replyTime"
                        }
                      ],
                      staticClass: "my-banner-p"
                    },
                    [
                      _c("span", { staticClass: "my-banner-p-bold" }, [
                        _vm._v("回复时间：")
                      ]),
                      _vm._v(
                        _vm._s(
                          _vm.$myConvertTimeDetails(_vm.myForm.replyTime)
                        ) + "\n            "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.myForm.replyContent,
                          expression: "myForm.replyContent"
                        }
                      ],
                      staticClass: "my-banner-p"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "my-banner-p-bold my-textarea" },
                        [_vm._v("回复内容：")]
                      ),
                      _c("p", [_vm._v(_vm._s(_vm.myForm.replyContent))])
                    ]
                  ),
                  _c("div", { staticClass: "my-banner-p" }, [
                    _c("span", { staticClass: "my-banner-p-bold" }, [
                      _vm._v("反馈结果：")
                    ]),
                    _c(
                      "span",
                      {
                        class: _vm.myForm.fbResults ? "my-color1" : "my-color2"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.myForm.fbResults ? "已回复" : "待回复")
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.myForm.supReply,
                          expression: "myForm.supReply"
                        }
                      ],
                      staticClass: "my-banner-p"
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "my-banner-p-bold my-textarea" },
                        [_vm._v("补充回复：")]
                      ),
                      _c("p", [_vm._v(_vm._s(_vm.myForm.supReply))])
                    ]
                  )
                ])
              ])
            : _c("div", [_c("p", [_vm._v("无历史投诉建议信息！")])])
        ]),
        _c(
          "div",
          { class: _vm.prevId ? "my-banner-left" : "my-banner-right" },
          [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.prevId,
                    expression: "prevId"
                  }
                ],
                staticClass:
                  "my-banner-prev overflowText font24phone displayIB",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.getsuggestionsList(_vm.prevId)
                  }
                }
              },
              [_vm._v(_vm._s("<上一条 ") + "\n        ")]
            ),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.nextId,
                    expression: "nextId"
                  }
                ],
                staticClass:
                  "my-banner-next overflowText font24phone displayIB",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.getsuggestionsList(_vm.nextId)
                  }
                }
              },
              [_vm._v("下一条>")]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57800610", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57800610","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/about/suggestionsList/suggestionsList.vue
// module id = 1218
// module chunks = 9